import { render, staticRenderFns } from "./offer-hidden.vue?vue&type=template&id=b6100d28&scoped=true&"
var script = {}
import style0 from "./offer-hidden.vue?vue&type=style&index=0&id=b6100d28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6100d28",
  null
  
)

export default component.exports